import { Button } from "@/components/ui/baseUi/button"
import { Skeleton } from "@/components/ui/baseUi/skeleton"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/baseUi/tabs"
import { Text } from "@/components/ui/baseUi/text"
import { CoachAdminBanking } from "@/modules/coach/components/coachAdminBanking"
import { CoachAdminForm } from "@/modules/coach/components/coachAdminForm"
import { word } from "@modules/core/utils/i18n"
import { Suspense } from "react"

const VITRINE_FORM_ID = "coach-vitrine-form"

export function CoachAdminPage() {
  return (
    <div className="relative min-h-full w-full bg-surface-background-default p-6 pb-24">
      <div className="mb-6 flex flex-col gap-1">
        <Text fontStyle="HL" className="font-semibold text-textOnSurface-default">
          {word("coach.admin.page.title")}
        </Text>
        <Text fontStyle="BM" className="text-textOnSurface-subtle">
          {word("coach.admin.page.subtitle")}
        </Text>
      </div>

      <Tabs defaultValue="vitrine">
        <TabsList className="mb-6">
          <TabsTrigger value="vitrine">{word("coach.admin.tab.vitrine")}</TabsTrigger>
          <TabsTrigger value="banking">{word("coach.admin.tab.banking")}</TabsTrigger>
        </TabsList>

        <TabsContent value="vitrine">
          <Suspense fallback={<Skeleton className="h-96 w-full rounded-2xl" />}>
            <CoachAdminForm formId={VITRINE_FORM_ID} />
          </Suspense>
        </TabsContent>

        <TabsContent value="banking">
          <CoachAdminBanking />
        </TabsContent>
      </Tabs>

      <div className="fixed right-6 bottom-6 z-10">
        <Button variant="primary" type="submit" form={VITRINE_FORM_ID}>
          {word("coach.admin.save")}
        </Button>
      </div>
    </div>
  )
}
